import React, { useState } from "react";

function CustomerDetailsBox({
    selectedShop,
    files,
    selectedMode,
    onBack,
    onSubmit,
    isSent,
    isSending,
    onStartNewOrder
}) {
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");

    const canSubmit = email.trim() && name.trim();


    return (
        isSent ? (
            <div className="w-full max-w-[520px] bg-white rounded-[20px] shadow-[0px_2px_28px_0px_rgba(0,0,0,0.07)] p-[32px] md:p-[48px] flex flex-col items-center gap-[24px] text-center">
                <div
                    className="w-[72px] h-[72px] rounded-full bg-[#e8f8e8] flex items-center justify-center"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        className="lucide lucide-check w-[36px] h-[36px] text-[#2ecc71]">
                        <path d="M20 6 9 17l-5-5"></path>
                    </svg>
                </div>
                <div>
                    <h1 className="font-semibold text-[26px] text-[#212326] mb-[8px]">
                        Sent successfully!
                    </h1>

                    <p className="font-semibold text-[15px] text-[#717182] leading-[1.6]">
                        Your {files.length} file{files.length > 1 ? "s" : ""} has been sent to
                        <span className="font-bold text-[#212326] ml-[3px]">
                            {selectedShop?.shopName || "This shop"}.
                        </span> Happy Printing!
                        <span className="font-semibold text-[#ff5323] ml-[3px]">
                            {email}
                        </span>.
                    </p>
                </div>

                <button
                    onClick={onStartNewOrder}
                    className="px-[24px] py-[11px] rounded-[10px] bg-[#ff5323] text-white font-semibold text-[14px] hover:bg-[#e64a1f] transition-colors"
                >
                    Start New Order
                </button>
            </div>
        ) : (
            <div className="w-full max-w-[720px] bg-white rounded-[16px] shadow-[0px_2px_28px_0px_rgba(0,0,0,0.07)] p-[24px] md:p-[40px] flex flex-col gap-[24px]">

                {/* Header */}
                <div>
                    <h1 className="font-semibold text-[24px] text-[#212326] mb-[6px]">
                        Your details
                    </h1>

                    <p className="font-medium text-[14px] text-[#717182]">
                        How should{" "}
                        <span className="font-semibold text-[#212326]">
                            {selectedShop?.shopName || "Unknown Shop"}
                        </span>{" "}
                        get back to you?
                    </p>
                </div>

                {/* Form */}

                <div className="flex flex-col gap-[16px]">

                    <div className="flex flex-col md:flex-row gap-[16px]">

                        {/* Email */}
                        <div className="flex-1 flex flex-col gap-[6px]">
                            <label className="font-semibold text-[14px] text-[#212326]">
                                Email Address *
                            </label>

                            <div className="relative">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="absolute left-[14px] top-1/2 -translate-y-1/2 w-[18px] h-[18px] text-[#9298a0]"
                                >
                                    <rect width="20" height="16" x="2" y="4" rx="2" />
                                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
                                </svg>

                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="your@email.com"
                                    className="w-full h-[48px] rounded-[12px] border border-[#e4e5e7] pl-[40px] pr-[16px] font-semibold text-[14px] text-[#212326] placeholder:text-[#9298a0] focus:outline-none focus:border-[#ff5323] transition-colors"
                                />
                            </div>
                        </div>

                        {/* Name */}
                        <div className="flex-1 flex flex-col gap-[6px]">
                            <label className="font-semibold text-[14px] text-[#212326]">
                                Name *{" "}
                                {/* <span className="font-semibold text-[#9298a0] text-[12px]">
                                    (optional)
                                </span> */}
                            </label>

                            <input
                                type="text"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder="Your name"
                                className="w-full h-[48px] rounded-[12px] border border-[#e4e5e7] px-[16px] font-semibold text-[14px] text-[#212326] placeholder:text-[#9298a0] focus:outline-none focus:border-[#ff5323] transition-colors"
                            />
                        </div>
                    </div>

                    {/* Phone */}
                    <div className="flex flex-col md:flex-row gap-[16px]">
                        <div className="flex-1 flex flex-col gap-[6px]">
                            <label className="font-semibold text-[14px] text-[#212326]">
                                Phone{" "}
                                <span className="font-semibold text-[#9298a0] text-[12px]">
                                    (optional)
                                </span>
                            </label>

                            <input
                                type="tel"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                                placeholder="Your phone number"
                                className="w-full h-[48px] rounded-[12px] border border-[#e4e5e7] px-[16px] font-semibold text-[14px] text-[#212326] placeholder:text-[#9298a0] focus:outline-none focus:border-[#ff5323] transition-colors"
                            />
                        </div>

                        <div className="flex-1" />
                    </div>
                </div>


                {/* Summary */}
                <div className="bg-[#fafafa] rounded-[14px] p-[20px] flex flex-col gap-[12px] border border-[#e4e5e7]">

                    <p className="font-semibold text-[15px] text-[#212326]">
                        Order Summary
                    </p>

                    <div className="flex flex-col gap-[8px]">

                        <div className="flex items-center justify-between">
                            <span className="font-medium text-[13px] text-[#717182]">
                                Print Shop
                            </span>
                            <div className="flex items-center gap-[8px]">
                                <div className="w-[20px] h-[20px] rounded-[4px] overflow-hidden">
                                    <img
                                        src={selectedShop?.shopPhoto || `https://images.unsplash.com/photo-1767974785671-cfc4c8727147?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwcmludCUyMHNob3AlMjBzdG9yZWZyb250JTIwbW9kZXJufGVufDF8fHx8MTc3MjU2NDg3NHww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral`}
                                        alt=""
                                        className="w-full h-full object-cover" />
                                </div>
                                <span className="font-semibold text-[13px] text-[#212326]">
                                    {selectedShop?.shopName || "Unknown Shop"}
                                </span>
                            </div>
                        </div>

                        <div className="h-[1px] bg-[#e4e5e7]" />

                        <div className="flex justify-between">
                            <span className="font-medium text-[13px] text-[#717182]">
                                Files
                            </span>

                            <span className="font-semibold text-[13px] text-[#212326]">
                                {files?.length || 0} file{files?.length !== 1 ? "s" : ""}
                            </span>
                        </div>

                        <div className="flex justify-between">
                            <span className="font-medium text-[13px] text-[#717182]">
                                Mode
                            </span>

                            <span className="font-semibold text-[13px] text-[#212326]">
                                {selectedMode === "custom"
                                    ? "With Print Requirements"
                                    : "Quick Send"}
                            </span>
                        </div>

                    </div>
                </div>

                {/* Footer */}
                <div className="flex flex-col-reverse md:flex-row md:justify-between gap-[10px]">

                    <button
                        onClick={onBack}
                        className="flex items-center justify-center gap-[8px] w-full md:w-auto px-[20px] py-[12px] rounded-[10px] border border-[#e4e5e7] font-semibold text-[15px] text-[#212326] hover:bg-[#f4f5f6]"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-left w-[16px] h-[16px]">
                            <path d="m15 18-6-6 6-6"></path>
                        </svg>
                        Back
                    </button>

                    <button
                        disabled={!canSubmit || isSending}
                        onClick={() =>
                            onSubmit?.({
                                email,
                                name,
                                phone,
                            })
                        }
                        className={`flex items-center justify-center gap-[8px] w-full md:w-auto px-[20px] md:px-[28px] py-[12px] rounded-[10px] font-semibold text-[15px] transition-all
                        ${canSubmit
                                ? "bg-[#ff5323] text-white hover:bg-[#e64a1f]"
                                : "bg-[#e4e5e7] text-[#9298a0] cursor-not-allowed"
                            }`}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-send w-[16px] h-[16px]">
                            <path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z"></path>
                            <path d="m21.854 2.147-10.94 10.939"></path>
                        </svg>
                        {isSending ? "Sending..." : "Send to Print Shop"}
                    </button>

                </div>
            </div>
        )
    );
}

export default CustomerDetailsBox;